<template>
  <div class="p-2">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{$t('Commissions')}}
            </h5>
            <b-button v-permission="'change_receipt'" class="float-right p-0" variant="link" @click="toggleCommissionsModal(true)">
              <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
              {{$t('Edit')}}
            </b-button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 border-right">
                <table v-if="commissions && commissions.length > 0" class="info-table table table-sm">
                  <tr>
                    <th class="border-top-0">{{$t('Percentage')}}</th>
                    <th class="border-top-0" v-if="commissions.length > 1">{{$t('Over')}}</th>
                  </tr>
                  <tr v-for="(commission, index) in commissions" :key="index">
                    <td>{{commission.percent}} %</td>
                    <td v-if="commissions.length > 1">{{(commission.amount_over || 0) | asCurrency}}</td>
                  </tr>
                </table>
                <no-data-available v-else :height="5"/>
              </div>
              <div class="col-md-6">
                <table class="info-table table mb-0 table-sm">
                  <tr>
                    <td class="border-top-0 font-weight-bold">{{$t('Minimum commission')}}</td>
                    <td class="border-top-0">{{minimum_commission | asCurrency}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{$t('L/D Warranty ')}}</td>
                    <td>{{insurance_rate | asPercentage}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{$t('Entry Fee')}}</td>
                    <td>{{lot_handling_charge | asCurrency}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{$t('Rebate')}}</td>
                    <td>{{rebate_rate | asPercentage}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <commissions-modal/>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import CommissionsModal from "./modals/CommissionsModal";
  import helperService from "@/core/services/helper.service";
  import cloneDeep from "lodash/cloneDeep";

  const {mapState, mapActions} = createNamespacedHelpers('receipts');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "Terms",
    components: {
      CommissionsModal, NoDataAvailable
    },
    methods: {
      ...mapActions([
        'toggleCommissionsModal',
        'getTermsData'
      ]),
    },
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt,
        commissions: state => {
          let data = helperService.reverseCalculateTiers({commissions: cloneDeep(state.view.termsData.commissions)})
          return data.commissions
        },
        lot_handling_charge: state => state.view.termsData.lot_handling_charge,
        insurance_rate: state => state.view.termsData.insurance_rate,
        minimum_commission: state => state.view.termsData.minimum_commission,
        rebate_rate: state => state.view.termsData.rebate_rate,
      }),
    },
    mounted() {
      this.getTermsData();
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";
</style>

